import { useState } from 'react';
import Layout from '@/components/layout/Layout';
import ProductPriceAdvantageRanking from '@/components/benchmark/ProductPriceAdvantageRanking';

export default function RankingsVolume() {
  const [filters, setFilters] = useState({
    dateFrom: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
    dateTo: new Date().toISOString().split('T')[0],
    frequency: 'daily' as const,
    comparisonType: 'avg' as const,
  });

  return (
    <Layout>
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold">High-Impact Products</h1>
          <p className="text-muted-foreground mt-2">
            Products ranked by opportunity score: a combination of price advantage, consistency, and market frequency showing the highest impact potential.
          </p>
        </div>

        <ProductPriceAdvantageRanking
          rankingType="volume"
          dateFrom={filters.dateFrom}
          dateTo={filters.dateTo}
          frequency={filters.frequency}
          comparisonType={filters.comparisonType}
        />
      </div>
    </Layout>
  );
}
